import { jsx as C } from "react/jsx-runtime";
const e = ({
  width: t,
  height: L,
  className: o
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: o,
    fill: "none",
    height: L,
    viewBox: "0 0 24 24",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M2.15004 11.9991L2.15003 11.9977C2.14907 11.8765 2.17214 11.7564 2.21789 11.6442C2.2569 11.5644 2.30758 11.4908 2.36827 11.4258L2.37355 11.4202L2.37823 11.414C2.39501 11.3918 2.40826 11.3676 2.41507 11.3552C2.41602 11.3535 2.41685 11.352 2.41754 11.3507C2.42206 11.3426 2.42433 11.3391 2.42506 11.338L9.34067 4.42242C9.51526 4.24784 9.75205 4.14976 9.99895 4.14976C10.2458 4.14976 10.4826 4.24784 10.6572 4.42242L10.7633 4.31636L10.6572 4.42242C10.8318 4.59701 10.9299 4.8338 10.9299 5.0807C10.9299 5.3276 10.8318 5.56439 10.6572 5.73897L5.58413 10.8121L5.32807 11.0681H5.6902H20.3762C20.6231 11.0681 20.8598 11.1662 21.0343 11.3407C21.2089 11.5153 21.3069 11.752 21.3069 11.9989C21.3069 12.2457 21.2089 12.4825 21.0343 12.657C20.8598 12.8315 20.6231 12.9296 20.3762 12.9296H5.6902H5.32798L5.58415 13.1857L10.6608 18.2605C10.6608 18.2605 10.6608 18.2606 10.6608 18.2606C10.8354 18.4351 10.9334 18.6719 10.9334 18.9188C10.9334 19.1657 10.8354 19.4025 10.6608 19.5771C10.4862 19.7517 10.2494 19.8498 10.0025 19.8498C9.7556 19.8498 9.51881 19.7517 9.34423 19.5771L2.43055 12.6634C2.42939 12.6617 2.42669 12.6575 2.42109 12.6475C2.42049 12.6464 2.41981 12.6451 2.41905 12.6438C2.41189 12.6308 2.39789 12.6054 2.37898 12.5819L2.37929 12.5817L2.37182 12.5737C2.31099 12.5086 2.26021 12.4348 2.22116 12.3547C2.17401 12.2421 2.14983 12.1212 2.15004 11.9991Z",
        fill: "currentColor",
        stroke: "white",
        strokeWidth: "0.3"
      }
    )
  }
);
export {
  e as Content
};
